import React from 'react';
import * as styles from './MobilePreview.css';

interface StringPreviewProps {
  value: string;
  name: string;
  maxLen: number;
}

export const StringPreview = ({ value, name, maxLen }: StringPreviewProps) => {
  if (!value)
    return <span className={styles.empty}>{`Please fill out "${name}"`}</span>;
  const trimmed = value.slice(0, maxLen);
  return <>{`${trimmed}${value.length > trimmed.length ? '...' : ''}`}</>;
};
